import React, {useContext, useEffect, useState} from "react";
import {ChartContext} from "./chart/providers";
import {SettingsContext} from "./providers";

export default function UlopolisTabs() {
    const {chart, active, setActive} = useContext(ChartContext);
    const [state, setState] = useState({tabs: ''})
    const settings = useContext(SettingsContext)

    const setActiveM = (chartId) => {
        if (!chart || !chartId) return;
        chart.setActive(chartId);
        setActive(chartId);
        window.location.hash = chartId
    }

    useEffect(() => {
        if (!chart) return;
        const config = chart.chartOptions;

        const tabs = [...Object.keys(config)].filter(x => settings.charts[x].display).map((key) => (
            <li key={`${key}-tab`} className={active === key ? 'active' : ''} onClick={() => setActiveM(key)}>
                <div>
                    <img src={settings.charts[key].img} />
                    <span>{config[key].options.plugins.title.text}</span>
                </div>
            </li>))

        setState(state => ({...state, tabs: tabs}));
    }, [chart, active])


    return (
        <div className={'ulopolis-tabs-container'}>
            <ul className={'ulopolis-tabs'}>{state.tabs}</ul>
        </div>
    )
}
